import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CompoundTool } from "../components/CompoundTool";
import { CpBreadcrumb } from "../components/CpBreadcrumb";
import { CpExplainer } from "../components/CpExplainer";

export function CompoundInterestPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CpBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.cp_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.cp_intro()}
          </p>
        </header>

        <CompoundTool />

        <CpExplainer
          howTo={m.cp_howto()}
          faqs={[
            { q: m.cp_faq1_q(), a: m.cp_faq1_a() },
            { q: m.cp_faq2_q(), a: m.cp_faq2_a() },
            { q: m.cp_faq3_q(), a: m.cp_faq3_a() },
            { q: m.cp_faq4_q(), a: m.cp_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
